import Form from "../UI/Form/Form";
import "./FormPage.css";

const FormPage = () => {
  return (
    <div className="form-container">
      <Form />
    </div>
  );
};
export default FormPage;
